<template>
  <div class="block-info">
    <div class="block-info__container">
      <section class="block-info__section">
        <p>
          ContextUs — технологическая компания, специализирующаяся на автоматизации рекламных кампаний 
          крупных клиентов в системах контекстной рекламы, социальных сетях, продвижении мобильных приложений, 
          маркетплейсах и прайс-агрегаторах. Занимаемся разработкой индивидуальных веб инструментов для нужд 
          крупных компаний на российском рынке, создаём автоматизированные решения для разработки графических 
          материалов и управления фидами товаров, готовим структуры веб аналитики "под ключ". Имеем собственный 
          штат программистов, дизайнеров и аналитиков и собственную систему автоматизации рекламы по анализу 
          и управлению размещением с веб версией и мобильным приложением.
        </p>
      </section>

      <section class="block-info__section">
        <h2>Услуги и стоимость</h2>

        <table class="info-table">
          <thead>
            <tr>
              <th>Услуги</th>
              <th>Стоимость</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Система ContextUS</td>
              <td>От 200 000 Руб/Месяц</td>
            </tr>
            <tr class="info-table__section-row">
              <td colspan="2">Система по управлению фидами</td>
            </tr>
            <tr>
              <td>До 300 000 товаров в фиде</td>
              <td>50 000 Рублей/Месяц</td>
            </tr>
            <tr>
              <td>От 300 000 до 1 000 000 товаров в фиде</td>
              <td>100 000 Рублей/Месяц</td>
            </tr>
            <tr>
              <td>От 1 000 000 до 2 000 000 товаров в фиде</td>
              <td>150 000 Рублей/Месяц</td>
            </tr>
            <tr>
              <td>От 2 000 000 и более товаров в фиде</td>
              <td>Индивидуально</td>
            </tr>
            <tr>
              <td>Услуги аналитиков</td>
              <td>3 500 Руб/Час</td>
            </tr>
            <tr>
              <td>Услуги дизайнеров</td>
              <td>3 500 Руб/Час</td>
            </tr>
            <tr>
              <td>Услуги программистов</td>
              <td>3 500 Руб/Час</td>
            </tr>
            <tr>
              <td>Исследование рынка</td>
              <td>От 200 000 Рублей</td>
            </tr>
            <tr>
              <td>Разработка индивидуальных ИТ инструментов</td>
              <td>Индивидуально</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section class="block-info__section">
        <h2>Подробнее об услугах различных отделов.</h2>

        <div>
          <h3>Услуги аналитиков:</h3>
          <ul class="block-info__list">
            <li>Продумывание, составление и презентация архитектуры данных клиентов.</li>
            <li>Внедрение новых продуктов: Matomo Tag Manager, Яндекс Метрика Про и другие.</li>
            <li>Анализ рынка на наличие новых продуктов и технологий.</li>
            <li>Прогнозирование бюджета на использование продуктов и технологий.</li>
            <li>Согласование продукта с иными отделами Агентства (отдел безопасности, юридический отдел и др.).</li>
            <li>Сбор и структурирование требований к продукту.</li>
            <li>Согласование дорожных карт с сотрудниками Агентства и руководителем отдела аналитики.</li>
            <li>Техническая реализация новых продуктов (инструментов для аналитики):</li>
            <li>Развертывание облачных серверов.</li>
            <li>Использование языков программирования (Python, SQL, JavaScript и др.) для адаптирования новых продуктов под задачи и нужды Агентства.</li>
            <li>Введение проекта по созданию продукта собственной разработки для расширенного статистического анализа.</li>
            <li>Организация периодических статусов по реализации продукта.</li>
            <li>Ведение документации.</li>
            <li>Презентация результатов для сотрудников Агентства и руководителя отдела аналитики.</li>
            <li>Обучение сотрудников Агентства по использованию новых продуктов и технологий.</li>
            <li>Подготовка и участие в презентациях исследований для Агентства.</li>
            <li>Внедрение новых рекламных интеграций вместе с другими сотрудниками Агентства.</li>
            <li>Написание технического задания на разметку сайта</li>
            <li>Определение задач продукта.</li>
            <li>Ведение документации и реестра по написанным техническим заданиям всеми специалистами.</li>
            <li>
              Яндекс.Метрика:
              <ul class="block-info__list block-info__list--checks">
                <li>Периодическая проверка сбора статистики в Яндекс.Метрику.</li>
                <li>Проверка и консультация сотрудников по созданным целям, сегментам, аудиториям и пользовательским параметрам.</li>
                <li>Сбор требований к построению индивидуальных воронок продаж и специальных отчётов.</li>
                <li>Поддержка и проверка корректного функционирования Яндекс.Метрики.</li>
              </ul>
            </li>
            <li>
              Отчётность:
              <ul class="block-info__list block-info__list--checks">
                <li>Ведение документации всех витрин данных, построенных при помощи SQL запросов.</li>
                <li>Построение структуры визуализации данных в Microsoft Power BI.</li>
                <li>Презентация реализованных отчётов сотрудникам Агентства.</li>
                <li>Сбор дополнительных требований и доработок к новым и уже существующим автоматизированным отчётам.</li>
              </ul>
            </li>
            <li>
              A/B тесты:
              <ul class="block-info__list block-info__list--checks">
                <li>Ведение документации созданного продукта собственной разработки для расширенного статистического анализа.</li>
                <li>Презентация анализа полученных результатов.</li>
                <li>Консультация сотрудников Агентства по процессу и результатам A/B - тестирования.</li>
              </ul>
            </li>
            <li>
              Ретеншениринг:
              <ul class="block-info__list block-info__list--checks">
                <li>Группировка исследуемых событий на верхнеуровневые(макро) и низкоуровневые(микро) показатели.</li>
                <li>Помощь в анализе поведения пользователей на основе полученных результатов.</li>
                <li>Презентация результатов исследования и генерация гипотез для принятия решений</li>
              </ul>
            </li>
          </ul>
        </div>
      </section>

      <section class="block-info__section">
        <h2>Описание технологического стека:</h2>
        <div>
          <p><b>Языки программирования и фреймворки:</b> Golang, PHP, Python, HTML, CSS, JavaScript, Symfony, Laravel, Doctrine ORM, Sentry SDK, PHP-CS-Fixer, PHPLint, Vue, 1С Битрикс, WordPress, Slim</p>
          <p><b>Языки запросов:</b> SQL, MQL</p>
          <p><b>Серверное ПО и инфраструктура:</b> Nginx, Mariadb, Redis, Docker, Composer, Php-fpm, clickhouse, git, kubernetes, node.js</p>
        </div>
      </section>

      <section class="block-info__section">
        <h2>Акционерное общество «Контекстус»</h2>
        <div>
          <p><b>Краткое наименование:</b> АО «Контекстус»</p>
          <p><b>ИНН/КПП</b> 9701179641 / 770101001</p>
          <p><b>ОГРН:</b> 1217700286561</p>
          <p><b>ОКВЭД:</b></p>
          <p><b>Основной вид деятельности:</b> 62.01</p>
          <p><b>Дополнительные виды деятельности:</b> 58.29,62.03, 63.12, 72.20, 73.11</p>
          <p><b>Адрес (юридический, фактический и почтовый):</b></p>
          <p>105005, г. Москва, ул. Малая Почтовая, д. 2/2, стр. 1</p>
          <p><b>Телефон:</b> 8 (495) 744-44-04</p>
          <p><b>Электронная почта:</b> support@contextus.ru</p>
          <p><b>Коды видов деятельности по приказу Минцифры от 11.05.2023 № 449:</b> 1.01, 3.01, 12.01</p>
          <p><b>Государственная регистрация программы для ЭВМ:</b></p>
          <p>«ContextUs – система аналитики и управлении рекламой»</p>
          <p><b>Номер регистрации (свидетельства) –</b> 2022618955</p>
          <p><b>Дата регистрации –</b> 18.05.2022</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoBlock'
}
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.block-info {
  width: 100%;
  background-color: var(--default-violet);
  padding: 90px 0;

  &__container {
    max-width: 1200px;
    padding: 0 20px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  &__section {
    background-color: rgba(#ffffff, 0.05);
    border: 1px solid rgba(#ffffff, 0.08);
    border-radius: 24px;
    padding: 32px;
    box-shadow: 0 20px 40px rgba(#000000, 0.18);

    h2,
    h3 {
      margin: 0 0 0.5em 0;
    }

    h2 {
      font-size: 32px;
    }

    h3 {
      font-size: 22px;
    }

    p {
      font-size: 18px;
      line-height: 160%;
      margin: 0 0 0.6em 0;
    }
  }

  &__list {
    margin: 0;
    padding: 0 0 0 22px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    li {
      line-height: 160%;
    }

    &--checks {
      list-style: none;
      padding: 10px 0 0 0;

      li {
        position: relative;
        padding-left: 20px;

        &::before {
          content: '✔';
          position: absolute;
          left: 0;
          top: 0;
          font-size: 0.7em;
        }
      }
    }
  }
}

.info-table {
  width: 100%;
  border-collapse: collapse;

  thead {
    th {
      background: rgba(#ffffff, 0.1);
      border: 1px solid rgba(#ffffff, 0.12);
      padding: 1.125em 1.25em;
      font-size: 16px;
      font-weight: 700;
      text-align: left;
    }
  }

  tbody {
    td {
      border: 1px solid rgba(#ffffff, 0.1);
      font-size: 16px;
      padding: 1.375em 1.25em;
    }
  }

  &__section-row {
    td {
      text-align: center;
    }
  }
}

@media (max-width: 980px) {
  .block-info {
    padding: 20px 0 30px;

    &__container {
      padding: 0 12px;
      gap: 16px;
    }

    &__section {
      padding: 20px;
      border-radius: 18px;

      h2 {
        font-size: 24px;
      }

      h3 {
        font-size: 19px;
      }

      p {
        font-size: 15px;
      }
    }
  }

  .info-table {
    thead {
      th {
        font-size: 15px;
      }
    }

    tbody {
      td {
        font-size: 15px;
      }
    }
  }

  .info-list {
    li {
      font-size: 15px;
    }
  }
}
</style>
